import { Stepper, StepperProps } from "@mantine/core";

export type Step = {
  label: string;
  description: string;
}

export type CustomStepperProps = {
  steps: Step[];
  active?: number;
} & Omit<StepperProps, 'active' | 'children'>;

export const CustomStepper = (props: CustomStepperProps) => {
  const { steps, active = 0, ...rest } = props;

  return <Stepper active={active} {...rest}>
    {steps.map(record => <Stepper.Step
      label={record.label}
      description={record.description}
      key={`stepper-key-${record.label}`}
    />)}
  </Stepper>
}